module.exports = __webpack_public_path__ + "img/absolut-form-bg.424e6466.jpg";